import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ProfileForm from '../../components/Profile/profileForm';
import ProfileContact from '../../components/Profile/profileContact';
import { getAccountInfo, getWhatsappUrl } from '../../redux/actions/auth';
import { Loading } from '../../components';
import styles from './profile.module.css';

function UserProfile() {
  const dispatch = useDispatch();

  const auth = useSelector((state) => state.auth);
  const loading = auth?.loading;
  useEffect(() => {
    dispatch(getAccountInfo());
    dispatch(getWhatsappUrl());
  }, [dispatch]);

  return (
    <>
      {loading && (
        <div className={styles['loadingContainer']}>
          <Loading />
        </div>
      )}
      <ProfileForm />
      <ProfileContact />
    </>
  );
}

export default UserProfile;
